export default function RadioButtonUnchecked({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height={height} width={width} viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g fill='currentColor'>
        <path d='M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16z' />
      </g>
    </svg>
  );
}
